import appData from './app-data'
import appEvent from './app-event'
import routerStatus from './router-status'
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

 const store = new Vuex.Store({
    strict: debug, //在非生产环境下，使用严格模式
    modules: {
        appData, routerStatus, appEvent
    },
    state:{
    	config:{
    		webdomain:'',
    		domain:'',
    		data:null
    	},
    	userInfo:{
        unionid:''
      },
      keepAlive:{},
      type:''
    },
    mutations: {
    	updateWebdomain(state,webdomain){
    		if(state.config.webdomain != webdomain){
    			state.config.webdomain = webdomain;
    		}
    	},
    	updateDomain(state, domain){
    		state.config.domain = domain;
    	},
      updateUser(state, user){
        	state.userInfo = user;
      },
      updateKeepAlive(state,keepAlive){
        state.keepAlive = keepAlive;
      },
      updateJtype(state,jtype){
        state.config.jtype = jtype;
      },
      updateStarturl(state,starturl){
        state.config.starturl = starturl;
      },
      updateData(state,data){
        state.config.data = data;
      }


    },
    actions: {
    	updateWebdomain({commit}, webdomain){
    		commit("updateWebdomain", webdomain);
    	},
    	updateDomain({commit}, domain){
    		commit("updateDomain", domain);
    	}
      ,
      updateUser({commit}, user){
      	commit("updateUser", user);
      },
      updateKeepAlive({commit}, keepAlive){
      	commit("updateKeepAlive", keepAlive);
      },
      updateJtype({commit}, jtype){
        commit("updateJtype", jtype);
      },
      updateStarturl({commit}, starturl){
        commit("updateStarturl", starturl);
      },
      updateData({commit}, starturl){
        commit("updateData", starturl);
      }

    }
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js